import React from 'react';
import TweenOne from 'rc-tween-one';
import RcScrollElement from 'rc-scroll-anim/lib/ScrollElement';
import QueueAnim from 'rc-queue-anim';
import { Typography } from 'antd';

export default function Page4() {
  return (
    <RcScrollElement id="page4" className="content-wrapper page">
      <QueueAnim
        className="text-wrapper-bottom"
        key="text"
        leaveReverse
        type="bottom"
      >
        
        <Typography.Paragraph
            type={'secondary'}
            style={{
                fontSize: 24,
                marginBottom: 0
            }}
        >
            04
        </Typography.Paragraph>
        <br/>
        <h2 key="h2">
          Affordable
        </h2>
        <p key="p">
        FAREati delivers <b>long-term</b> cost <b>savings</b> through <b>seamless</b> system <b>integration</b>.
        </p>
      </QueueAnim>
      <TweenOne
        key="image"
        className="image4 bottom-wrapper"
        animation={{
          y: 0, opacity: 1, duration: 550, delay: 150, ease: 'easeOutQuad',
        }}
        style={{ transform: 'translateY(50px)', opacity: 0 }}
      />
    </RcScrollElement>
  );
}
